// ZZZ URL alias: /game/guide/zzz/drivedisc/<id> renders the same detail page
// as /echo/<id> (the component adapts its labels per game).
// getStaticPaths/getStaticProps must be re-exported explicitly — Next.js does
// not pick up data-fetching functions through `export { default }`.
export { default, getStaticPaths, getStaticProps } from '../echo/[echoId]'
